// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// HG Pro components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function Breadcrumbs({ icon, title, route, fullPath, light }) {

  const roleSegments = ["super-admin", "admin", "manager", "concierge", "user",];

  // Remove last segment (current page)
  const routes = route.slice(0, -1);

  // Split actual full URL (this preserves orgId / propertyId etc)
  const segments = fullPath.split("/").filter(Boolean);

  // Build cumulative path safely
  const buildPath = (index) => {
    return "/" + segments.slice(0, index + 1).join("/");
  };

  return (
    <SoftBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        {/* Home */}
        <Link to="/">
          <SoftTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </SoftTypography>
        </Link>

        {/* Dynamic breadcrumb links */}
        {/* {routes.map((el, index) => (
          <Link to={buildPath(index)} key={index}>
            <SoftTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el.replace("-", " ")}
            </SoftTypography>
          </Link>
        ))} */}

        {/* Role not Clickable */}
        {routes.map((el, index) => {
          const isRole = roleSegments.includes(el.toLowerCase());

          const content = (
            <SoftTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el.replace("-", " ")}
            </SoftTypography>
          );

          return isRole ? (
            <SoftBox key={index}>{content}</SoftBox> // Not clickable
          ) : (
            <Link to={buildPath(index)} key={index}>
              {content}
            </Link>
          );
        })}

        {/* Current page (non-clickable) */}
        <SoftTypography
          variant="button"
          fontWeight="regular"
          textTransform="capitalize"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replace("-", " ")}
        </SoftTypography>
      </MuiBreadcrumbs>
    </SoftBox>
  );
}

// Defaults
Breadcrumbs.defaultProps = {
  light: false,
};

// Props
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  fullPath: PropTypes.string.isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
